import { render, staticRenderFns } from "./ReparationTypeManager.vue?vue&type=template&id=453d49de"
import script from "./ReparationTypeManager.vue?vue&type=script&lang=js"
export * from "./ReparationTypeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports